var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from '@mui/material';
import ExpandIcon from './expansion-icon';
import { StyledAccordionSummary, ExpansionSummaryHeader, ExpansionDataPoint, AccordionHeader } from './styles';
import { maxColumns } from '.';
export default function ExpansionSummary(_a) {
    var children = _a.children, details = _a.details, _b = _a.header, header = _b === void 0 ? false : _b, props = __rest(_a, ["children", "details", "header"]);
    var detailsLength = details.length;
    var mainColumnWidth = maxColumns - (2 * detailsLength);
    if (header) {
        return (_jsx(AccordionHeader, { children: _jsxs(Grid, __assign({ container: true }, { children: [_jsx(ExpansionSummaryHeader, __assign({ role: "columnheader", item: true, sm: mainColumnWidth, xs: mainColumnWidth, className: "ExpansionSummaryHeader" }, { children: children })), details.map(function (detail, index) { return (_jsx(ExpansionDataPoint, __assign({ role: "columnheader", item: true, sm: 2, xs: 2, sx: { display: { xs: 'flex', sm: 'flex', md: 'flex' } }, zeroMinWidth: true }, { children: detail }), "expansion-datapoint-".concat(detail === null || detail === void 0 ? void 0 : detail.toString()))); })] })) }));
    }
    return (_jsx(StyledAccordionSummary, __assign({ expandIcon: _jsx(ExpandIcon, {}), sx: { minHeight: '56px' } }, props, { children: _jsxs(Grid, __assign({ container: true }, { children: [_jsx(ExpansionSummaryHeader, __assign({ role: "columnheader", item: true, sm: mainColumnWidth, xs: mainColumnWidth, className: "ExpansionSummaryHeader" }, { children: children })), details.map(function (detail, index) { return (_jsx(ExpansionDataPoint, __assign({ role: "columnheader", item: true, sm: 2, xs: 2, sx: { display: { xs: 'flex', sm: 'flex', md: 'flex' } }, zeroMinWidth: true }, { children: detail }), "expansion-datapoint-".concat(detail === null || detail === void 0 ? void 0 : detail.toString()))); })] })) })));
}
